<template>
    <div class="operate-bar-box">
        <div class="date-search">
            <span class="data-search-label"
                ><span class="date-now" @click="dateNowClick">{{ todayLabel }}</span> / {{ dateLabel }}:</span
            >
            <SingleCalendar
                @dateSelect="setDateStart"
                class="time-start"
                :config="calendarConfig"
                :value="customDate.startTime"
                :disableRanges="disableRanges"
            />
            <span class="span-fgf"></span>
            <SingleCalendar
                @dateSelect="setDateEnd"
                class="time-end"
                :config="calendarConfig"
                :value="customDate.endTime"
                :disableRanges="disableRanges"
            />
        </div>
        <div class="type-search-content">
            <div class="lang-search">
                <span class="search-type-label">{{ langType }}</span>
                <LangSelect value="all" @change="langSelect" :requireAll="true" class="lang-select"></LangSelect>
            </div>
            <div class="question-search">
                <span class="search-type-label">{{ questionType }}</span>
                <Select initValue="all" :options="questionOptions" class="question-select" @menuClick="questionChange" />
            </div>
            <div class="channel-search">
                <span class="search-type-label">{{ channelType }}</span>
                <ChannelSelect value="all" @change="channelChange" />
            </div>
        </div>
    </div>
</template>

<script>
import SingleCalendar from "@/views/zhiji/bComponents/calendar/SingleCalendar";
import Select from "@/views/zhiji/bComponents/inputs/Select";
import LangSelect from "@/components/langSelect";
import ChannelSelect from "@/views/zhiji/components/channelSelect/index";

import { questionTypeOptions } from "@/views/zhiji/components/pagesPanel/pagesConfig.js";

export default {
    name: "TopOperateBar",
    components: {
        SingleCalendar,
        Select,
        ChannelSelect,
        LangSelect
    },
    data() {
        return {
            calendarConfig: {
                position: "left",
                hasRadius: true,
                dateFormat: "YYYY/MM/DD hh:mm"
            },
            customDate: {
                startTime: new Date(this.getYesterday().start),
                endTime: new Date(this.getYesterday().end)
            },
            disableRanges: [
                {
                    start: new Date(Date.now()) // 今天不可选
                }
            ]
        };
    },
    computed: {
        questionOptions() {
            return questionTypeOptions();
        },
        dateLabel() {
            return this.$t("zhiji.hotSpot.dateLabel");
        },
        todayLabel() {
            return this.$t("zhiji.dataPanel.yesterday");
        },
        questionType() {
            return this.$t("zhiji.hotSpot.questionType");
        },
        channelType() {
            return this.$t("zhiji.hotSpot.channelType");
        },
        langType() {
            return this.$t("zhiji.common.language");
        }
    },
    methods: {
        setDateStart(date) {
            this.customDate.startTime = new Date(this.zhiji.dateFormat(date));

            this.$emit("updateTime", {
                type: "start",
                value: this.zhiji.dateFormat(date)
            });
        },
        setDateEnd(date) {
            this.customDate.endTime = new Date(this.zhiji.dateFormat(date));

            this.$emit("updateTime", {
                type: "end",
                value: this.zhiji.dateFormat(date)
            });
        },
        questionChange(data) {
            this.$emit("quesTypeChange", data);
        },
        channelChange(data) {
            this.$emit("channelChange", {
                value: data
            });
        },
        langSelect(data) {
            this.$emit("langSelect", {
                value: data
            });
        },
        dateNowClick() {
            (this.customDate = {
                startTime: new Date(this.getYesterday().start),
                endTime: new Date(this.getYesterday().end)
            }),
                this.$emit("dateNowClick", {
                    start: this.getYesterday().start.replace(/\//g, "-"),
                    end: this.getYesterday().end.replace(/\//g, "-")
                });
        },
        getYesterday() {
            let seconds = new Date(Date.now() - getDayMilliseconds() * 1);
            let start = this.zhiji.dateFormat(seconds, "YYYY/MM/DD 00:00");
            let end = this.zhiji.dateFormat(seconds, "YYYY/MM/DD 23:59");

            return {
                start,
                end
            };
        }
    }
};

// 一天的秒数
function getDayMilliseconds() {
    return 24 * 60 * 60 * 1000;
}
</script>

<style lang="scss" scoped>
.operate-bar-box {
    padding: 16px 24px 6px;
    border-radius: 6px;
    background: #fff;
    border: 1px solid #d8e4f0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .date-search {
        .data-search-label {
            margin-right: 8px;
        }

        .span-fgf {
            display: inline-block;
            vertical-align: middle;
            background: #e1eaf2;
            width: 12px;
            height: 1px;
            margin: 0 5px;
            position: relative;
            top: -1px;
        }

        .time-start,
        .time-end {
            width: 171px;
            height: 32px;
            margin-bottom: 10px;
            display: inline-block;
        }
    }

    .type-search-content {
        display: flex;

        .question-search,
        .channel-search,
        .lang-search {
            display: flex;
            align-items: center;
        }
        .channel-search {
            margin-bottom: 10px;
        }
        .question-search,
        .lang-search {
            margin: 0 8px 10px 0;
        }

        .search-type-label {
            margin-right: 8px;
        }

        .channel-select {
            width: 160px !important;
        }
        &:last-child {
            .select-opt {
                margin-right: 0;
            }
        }
    }

    .date-now {
        cursor: pointer;
    }

    .lang-select,
    .question-select {
        width: 120px;
    }
}
</style>
